import { render } from "./DarkMatterLogo.vue?vue&type=template&id=05508116&scoped=true"
import script from "./DarkMatterLogo.vue?vue&type=script&lang=js"
export * from "./DarkMatterLogo.vue?vue&type=script&lang=js"

import "./DarkMatterLogo.vue?vue&type=style&index=0&id=05508116&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05508116"]])

export default __exports__